// WebSocket configuration for Blob Chat
// This file can be replaced or modified for different environments (dev/prod)

// Determine environment - if running on localhost or 127.0.0.1, use dev config
const isDevelopment = window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '';

// WebSocket URL configuration
const WS_CONFIG = {
    // Development (localhost)
    development: 'ws://localhost:8787/api/ws',

    // Production (Cloudflare Workers)
    // Option 1: Custom domain route (same domain as frontend) - REQUIRES ROUTE SETUP IN CF DASHBOARD
    production: 'wss://zdar.jelinek.work/api/ws'

    // Option 2: Use workers.dev URL (uncomment if custom domain route doesn't work)
    // production: 'wss://blob-chat-api.your-subdomain.workers.dev/api/ws'
};

// Export the WebSocket URL based on environment
window.WEBSOCKET_URL = isDevelopment
    ? WS_CONFIG.development
    : WS_CONFIG.production;

// Export environment flag for other scripts
window.IS_DEVELOPMENT = isDevelopment;

if (isDevelopment) {
    console.log('WebSocket URL configured:', window.WEBSOCKET_URL);
    console.log('Environment:', 'development');
}

